export const getConnectionType = (score) => {
  if (score === 0) return "Walk Away";
  if (score >= 1 && score <= 8) return "Active Repulsion";
  if (score >= 9 && score <= 16) return "No Connection";
  if (score >= 17 && score <= 24) return "Weak Resonance";
  if (score >= 25 && score <= 32) return "Surface Rapport";
  if (score >= 33 && score <= 40) return "Friendly Connection";
  if (score >= 41 && score <= 48) return "Curious Interest";
  if (score >= 49 && score <= 56) return "Mutual Attraction";
  if (score >= 57 && score <= 64) return "Emotional Alignment";
  if (score >= 65 && score <= 72) return "Relational Chemistry";
  if (score >= 73 && score <= 80) return "Deep Bond";
  if (score >= 81 && score <= 89) return "Soul Connection";
  if (score >= 90 && score <= 100) return "Twin Flame";
  return "Unknown";
};

export const getConnectionColor = (score) => {
  if (score <= 8) return "text-red-500";
  if (score <= 24) return "text-orange-500";
  if (score <= 40) return "text-yellow-500";
  if (score <= 64) return "text-cyan-400";
  if (score <= 80) return "text-green-400";
  if (score <= 89) return "text-purple-400";
  return "text-white";  // Twin Flame = White (completing red-to-white spectrum)
};
